export const chempConstants = {
  /*********
   송/수신함 검색조건 변경
   **********/
  SELECT_SEARCH_REQUEST: 'SELECT_CERTBOX_SEARCH_REQUEST',

  /** 송신함 **/
    /*********
     송신함 목록 조회
     **********/
    SENDBOX_REQUEST: 'GET_SENDBOX_REQUEST',
    SENDBOX_SUCCESS: 'GET_SENDBOX_SUCCESS',
    SENDBOX_FAILURE: 'GET_SENDBOX_FAILURE',

    /*********
     송신함 원본 목록 조회
     **********/
    SENDBOX_ORG_REQUEST: 'GET_SENDBOX_ORG_REQUEST',
    SENDBOX_ORG_SUCCESS: 'GET_SENDBOX_ORG_SUCCESS',
    SENDBOX_ORG_FAILURE: 'GET_SENDBOX_ORG_FAILURE',

    /***********
     증명서 송신함 히스토리 관리
     ************/
    SENDBOX_HISTORY: 'SET_SENDBOX_HISTORY',


/** 수신함 **/

    /*********
     수신함 목록 조회
     **********/
    CERTBOX_REQUEST: 'GET_CERTBOX_REQUEST',
    CERTBOX_SUCCESS: 'GET_CERTBOX_SUCCESS',
    CERTBOX_FAILURE: 'GET_CERTBOX_FAILURE',

    CERTBOX_ORG_REQUEST: 'GET_CERTBOX_ORG_REQUEST',
    CERTBOX_ORG_SUCCESS: 'GET_CERTBOX_ORG_SUCCESS',
    CERTBOX_ORG_FAILURE: 'GET_CERTBOX_ORG_FAILURE',

    /***********
     증명서 수취완료
    ************/
    RECEIVE_REQUEST: 'RECEIVE_CERTIFICATE_REQUEST',
    RECEIVE_SUCCESS: 'RECEIVE_CERTIFICATE_SUCCESS',
    RECEIVE_FAILURE: 'RECEIVE_CERTIFICATE_FAILURE',

    /***********
     증명서 수신함 히스토리 관리
     ************/
    CERTBOX_HISTORY: 'SET_CERTBOX_HISTORY',

    /***********
     증명서 PDF BASE64STRING 조회
     ************/
    PDF_REQUEST: 'PDT_REQUEST',
    PDF_SUCCESS: 'PDF_SUCCESS',
    PDF_FAILURE: 'PDF_FAILURE',

    /***********
     PDF 호출 init 처리
     ************/
    INIT_FLAG_REQUEST: 'INIT_FLAG_REQUEST',

    /***********
     상태관련 state 초기화
     ************/
    CLEAR_REQUEST: 'CLEAR_REQUEST',

    /***********
     증명서 첨부파일 다운로드
     ************/
    FILE_REQUEST: 'FILE_REQUEST',
    FILE_SUCCESS: 'FILE_SUCCESS',
    FILE_FAILURE: 'FILE_FAILURE',

    /***********
     시험성적서 첨부파일 다운로드
     ************/
    FILE_DOWN_REQUEST: 'FILE_DOWN_REQUEST',
    FILE_DOWN_SUCCESS: 'FILE_DOWN_SUCCESS',
    FILE_DOWN_FAILURE: 'FILE_DOWN_FAILURE',

    /***********
     시험성적서 첨부파일 출력
     ************/
    DOWN_FILE_REQUEST: 'DOWN_FILE_REQUEST',
    DOWN_FILE_SUCCESS: 'DOWN_FILE_SUCCESS',
    DOWN_FILE_FAILURE: 'DOWN_FILE_FAILURE',

}
